import React, { useEffect, useState, useCallback } from "react";
import { MdOutlineFilterList } from "react-icons/md";
import { Col, Row } from "react-bootstrap";
import { ApiPaths } from "../../Config/ApiPath";
import Loader from "./../../Components/Loader/Loader";
import "./GenerationTeam.css";
import PaginationComponent from "../../Components/PaginationControls/PaginationControls";
import useAxiosHelper from "../../Common/AxiosHelper";
import { BasicInfo, toastFailed } from "../../Config/BasicInfo";
import moment from "moment";
import debounce from "lodash.debounce";
import { useSelector } from "react-redux";

const GenerationTeam = () => {
  const [selectLevel, setSelectLevel] = useState([]);
  const [filterVisibility, setFilterVisibility] = useState(false);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [limitFilter, setLimitFilter] = useState(20);
  const [dateFilter, setDateFilter] = useState("default");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const { AxiosGet, AxiosPost } = useAxiosHelper();
  const [generationTeam, setGenerationTeam] = useState([]);
  const [level, setLevel] = useState("");
  const [selfBusiness, setSelfBusiness] = useState();
  const [secondLevel, setSecondLevel] = useState("");
  const [teamBusiness, setTeamBusiness] = useState();
  const [companyData, setCompanyData] = useState([]);
  const [search, setSearch] = useState({
    username: "",
    name: "",
    self_investment: "",
    business: "",
    status: "",
    rank: "",
  });
  const profileData = useSelector(
    (state) => state.profileData.userPersonalInfo
  );
  const [rankName, setRankName] = useState([]);
  // const handleSearch = () => {
  //   setCurrentPage(1); // Reset to first page on search
  // };
  const rankNames = [
    { id: 1, name: "BRONZE" },
    { id: 2, name: "SILVER" },
    { id: 3, name: "GOLD" },
    { id: 4, name: "RUBY" },
    { id: 5, name: "SAFIRE" },
    { id: 6, name: "EMERALD" },
    { id: 7, name: "DIAMOND" },
    { id: 8, name: "AMBASSADOR" },
    { id: 9, name: "PRESIDENT" },
    { id: 10, name: "DIRECTOR" },
  ];
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    } else {
      setSearch((prev) => {
        const updatedSearch = { ...prev, [name]: value };
        Object.keys(updatedSearch).forEach((key) => {
          if (updatedSearch[key] === "" || updatedSearch[key] === 0) {
            delete updatedSearch[key];
          }
        });
        return updatedSearch;
      });
    }
  };
  const handleDateFilterChange = (e) => {
    const value = e.target.value;
    setDateFilter(value);
    const today = moment().endOf("day");
    let start = "";
    let end = "";
    switch (value) {
      case "today":
        start = today.startOf("day").format("YYYY-MM-DD");
        end = today.format("YYYY-MM-DD");
        break;
      case "yesterday":
        start = today.subtract(1, "days").startOf("day").format("YYYY-MM-DD");
        end = today.endOf("day").format("YYYY-MM-DD");
        break;
      case "this_week":
        start = today.startOf("week").format("YYYY-MM-DD");
        end = today.endOf("week").format("YYYY-MM-DD");
        break;
      case "this_month":
        start = today.startOf("month").format("YYYY-MM-DD");
        end = today.endOf("month").format("YYYY-MM-DD");
        break;
      default:
        start = "";
        end = "";
        break;
    }
    setStartDate(start);
    setEndDate(end);
  };
  const resetData = () => {
    setSearch({
      username: "",
      name: "",
      self_investment: "",
      business: "",
      status: "",
      rank: "",
    });
    setLevel("");
    setSecondLevel("");
    setLimitFilter(20);
    setStartDate("");
    setEndDate("");
    setDateFilter("default");
    setCurrentPage(1);
    FetchData(true);
  };
  const handleLimitChange = (e) => {
    setLimitFilter(e.target.value);
  };
  const handlePagination = (page) => {
    setCurrentPage(page);
  };
  const getLevels = async () => {
    try {
      const response = await AxiosGet(ApiPaths.getPackages);
      console.log("getLevels response", response);
      const levels = response?.packages?.level_income?.level;
      setSelectLevel(levels);
    } catch (error) {
      BasicInfo.isDebug && console.error("Error fetching levels:", error);
    }
  };
  var x = 0;
  useEffect(() => {
    if (x == 0) {
      getLevels();
      FetchData();
      CompanyInfo();
      x++;
    }
  }, [currentPage]);
  async function CompanyInfo() {
    try {
      const data = localStorage.getItem("companyData");
      setCompanyData(JSON.parse(data));
    } catch (error) {
      BasicInfo.isDebug && console.log(error);
    }
  }
  // const FetchData = async () => {
  //   try {
  //     const queryParams = {
  //       page: currentPage,
  //       limit: limitFilter,
  //     };
  //     if (levelNumber !== "All") {
  //       queryParams.from = levelNumber;
  //     }
  //     if (toNumber !== "All") {
  //       queryParams.to = toNumber;
  //     }
  //     if (startDate && endDate) {
  //       queryParams.startDate = startDate;
  //       queryParams.endDate = endDate;
  //     }

  //     setLoading(true);

  //     const response = await AxiosGet(
  //       `${ApiPaths.getALlTeam}?${new URLSearchParams(queryParams).toString()}`
  //     );
  //     BasicInfo.isDebug && console.log("getALlTeam response", response);
  //     setGenerationTeam(response?.data);
  //     setSelfBusiness(response?.totalSum?.business);
  //     setTeamBusiness(response?.totalSum?.levelbusiness);
  //     setTotalPages(response?.totalPages || 1);
  //   } catch (error) {
  //     BasicInfo.isDebug && console.error("Error fetching getALlTeam:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const FetchData = async (isReset = false) => {
    console.log("startDate", startDate);
    console.log("endDate", endDate);
    isReset = isReset == true ?? false;
    try {
      const queryParams = {
        page: currentPage,
        limit: limitFilter,
      };

      if (isReset == false) {
        if (level != "") {
          queryParams.from_level = level;
        }
        if (secondLevel != "") {
          queryParams.to_level = secondLevel;
        }
        if (startDate) {
          queryParams.startDateJoining = startDate;
        }
        if (endDate) {
          queryParams.endDateJoining = endDate;
        }

        // Include other search filters (only if they have values)
        Object.keys(search).forEach((key) => {
          if (search[key]) {
            queryParams[key] = search[key];
          }
        });
      }

      setLoading(true);

      const response = await AxiosGet(
        `${ApiPaths.getALlTeam}?${new URLSearchParams(queryParams).toString()}`
      );

      BasicInfo.isDebug && console.log("getALlTeam response", response);
      setGenerationTeam(response?.data);
      setSelfBusiness(response?.totalSum?.business);
      setTeamBusiness(response?.totalSum?.levelbusiness);
      setTotalPages(response?.totalPages || 1);
    } catch (error) {
      BasicInfo.isDebug && console.error("Error fetching getALlTeam:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <section className="dashboard">
        <div className="incomeSelectBox">
          {/* <select value={level} onChange={fetchIncome}>
            <option value="All">All Data</option>
            {Array.isArray(selectLevel) &&
              selectLevel.map((x, index) => (
                <option key={index} value={`Level ${index + 1}`}>
                  {`Level ${index + 1}`}
                </option>
              ))}
          </select> */}
          <div>
            <label htmlFor="levelInput">Select Level</label>
            <div id="selectLevelDiv">
              <div>
                <input
                  id="levelInput"
                  min={1}
                  type="number"
                  value={level}
                  onChange={(e) =>
                    setLevel(e.target.value ? parseInt(e.target.value, 10) : "")
                  }
                  placeholder="From"
                />
              </div>
              <div>
                <input
                  min={1}
                  type="number"
                  value={secondLevel}
                  onChange={(e) =>
                    setSecondLevel(
                      e.target.value ? parseInt(e.target.value, 10) : ""
                    )
                  }
                  placeholder="To"
                />
              </div>
              <button className="goButton" onClick={FetchData}>
                Go
              </button>
            </div>
          </div>

          <button onClick={() => setFilterVisibility(!filterVisibility)}>
            {filterVisibility ? "Hide Filters" : "Show Filters"}
            <i>
              <MdOutlineFilterList />
            </i>
          </button>
        </div>
        {filterVisibility && (
          <section className="filtersection inputPrimary">
            <Row className="gx-2 gy-2">
              <Col lg="2" md="4" xs="12">
                <input
                  type="text"
                  name="username"
                  placeholder="Username"
                  value={search.username}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4" xs="12">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={search.name}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4" xs="12">
                <input
                  type="text"
                  name="self_investment"
                  placeholder="Self Business"
                  value={search.self_investment}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4">
                <select
                  name="status"
                  id=""
                  value={search.status}
                  onChange={handleChange}
                >
                  <option value="">--Status--</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </Col>

              <Col lg="2" md="4" xs="12">
                <input
                  type="date"
                  name="startDate"
                  placeholder="Start Date"
                  value={startDate}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4" xs="12">
                <input
                  type="date"
                  name="endDate"
                  placeholder="End Date"
                  value={endDate}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4" xs="12">
                <select
                  name="rank"
                  id=""
                  value={search.rank}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    -- Select Rank --
                  </option>{" "}
                  {/* Default placeholder option */}
                  {/* <option value="NoRank">No Rank</option> */}
                  {rankNames.map((x) => (
                    <option key={x.id} value={x.name}>
                      {x.name}
                    </option>
                  ))}
                </select>
              </Col>
              <Col lg="2" md="4" xs="12">
                <div>
                  <select
                    name="dateFilter"
                    value={dateFilter}
                    onChange={handleDateFilterChange}
                  >
                    <option value="default">Default</option>
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                    <option value="this_week">This Week</option>
                    <option value="this_month">This Month</option>
                  </select>
                </div>
              </Col>
              <Col lg="2" md="4" xs="12">
                <div>
                  <select
                    name=""
                    value={limitFilter}
                    onChange={handleLimitChange}
                  >
                    <option value="">--All--</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                  </select>
                </div>
              </Col>
              {/* <Col lg="2" md="4" xs="6">
                <button onClick={handleSearch}>Search</button>
                </Col> */}
              <Col lg="2" md="4" xs="6">
                <button onClick={FetchData}>Search</button>
              </Col>
              <Col lg="2" md="4" xs="6">
                <button onClick={resetData}>Reset</button>
              </Col>
            </Row>
          </section>
        )}
        <section className="history">
          <div className="historyContentHeading">
            <h1 className="textHeading">Generation Team</h1>
            <div>
              <p>
                Business : {companyData?.token_sign}
                {selfBusiness}
              </p>
            </div>
          </div>

          <div className="table">
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Date Of Joining</th>
                  <th>Date Of Activation</th>
                  <th>User ID</th>
                  <th>Name</th>
                  <th>Level</th>
                  <th>Direct Team</th>
                  <th>Direct Business ({companyData?.token_sign})</th>
                  <th>Rank</th>
                  <th>Sponsor</th>
                  <th>Self Package ({companyData?.token_sign})</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {generationTeam?.map((x, i) => (
                  <tr key={i}>
                    <td>{i + 1 + limitFilter * (currentPage - 1)}</td>
                    <td>{moment(x?.joining_date).format("lll")}</td>
                    <td>
                      {x?.Activation_date
                        ? moment(x.Activation_date).format("lll")
                        : "-"}
                    </td>
                    <td>{x?.username}</td>
                    <td>{x?.name}</td>
                    <td>{x?.level}</td>
                    <td>{x?.direct_team}</td>
                    <td>{x?.direct_business}</td>
                    <td>{x?.rank}</td>
                    <td>{x?.sponsor_username}</td>
                    <td>{x?.self_investment}</td>
                    {x?.status == 0 ? (
                      <td>Inactive</td>
                    ) : (
                      <td style={{ color: "var(--colorSuccess" }}>Active</td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            {generationTeam?.length === 0 && <p>No history yet</p>}
          </div>
          {generationTeam?.length > 0 && (
            <PaginationComponent
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePagination}
            />
          )}
        </section>
      </section>
    </>
  );
};

export default GenerationTeam;
